export const api = {
  // endPoint: "http://localhost:5000",
  endPoint: "https://blogxer-backend.onrender.com",
  frontend: "https://blogxer.onrender.com",
};
